module.exports = __webpack_public_path__ + "static/media/product-three.0b9da4fe.svg";